import { MoneyApi } from "go-core/api/types";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import {
	SubscriptionApi,
	SubscriptionsApi,
} from "../../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { isSubscriptionActive } from "../../FormNew/services";

const renderBillingPeriod = (billingPeriod: string) => {
	if (billingPeriod === "MONTHLY") return "mies";
	if (billingPeriod === "YEARLY") return "rok";
	return "BLAD";
};

export const renderSubscriptionMoney = (billingPeriod: string, price: MoneyApi) => {
	if (!price) return undefined;
	return `${FormatMoney(price)}/${renderBillingPeriod(billingPeriod)}`;
};

export const renderSubscriptionDefaultMoney = (subscription: SubscriptionApi) => {
	if (!subscription) return undefined;
	return renderSubscriptionMoney(subscription.billing_period, subscription.total_money);
};

export const prepareAllSubscriptions = (original: SubscriptionsApi, compare: SubscriptionsApi) => {
	const allSubscriptions = [] as any[];
	original.subscriptions
		.filter((x) => isSubscriptionActive(x.status))
		.forEach((subscription) => {
			const addons = subscription.addons.map((addon) => {
				return {
					name: addon.name,
					addon_id: addon.addon_id,
					billing_period: subscription.billing_period,
					original: addon,
				} as any;
			}) as any[];
			const monthlySubscription = subscription.monthly_sub_item;
			if (monthlySubscription) {
				addons.push(
					...monthlySubscription.addons.map((addon) => {
						return {
							name: addon.name,
							addon_id: addon.addon_id,
							billing_period: monthlySubscription.billing_period,
							original: addon,
						} as any;
					})
				);
			}
			allSubscriptions.push({
				original: subscription,
				familyName: subscription.family_name,
				addons,
			});
		});
	compare.subscriptions
		.filter((x) => isSubscriptionActive(x.status))
		.forEach((subscription) => {
			let allSubscription = allSubscriptions.find(
				(x) => x.original && x.original.external_id === subscription.external_id
			);
			if (subscription.external_id) {
				allSubscription = allSubscriptions.find(
					(x) => x.original && x.original.external_id === subscription.external_id
				);
			}
			if (!allSubscription) {
				allSubscription = allSubscriptions.find(
					(x) =>
						x.original &&
						x.original.family_id === subscription.family_id &&
						x.original.edit_mode === subscription.edit_mode
				);
			}
			if (!allSubscription) {
				allSubscription = {
					estimate: subscription,
					familyName: subscription.family_name,
					addons: [],
				};
				allSubscriptions.push(allSubscription);
			}
			if (allSubscription) {
				allSubscription.estimate = subscription;
				subscription.addons.forEach((addon) => {
					const existAddon = allSubscription.addons.find(
						(x: any) => x.addon_id === addon.addon_id && x.billing_period === subscription.billing_period
					);
					if (existAddon) {
						existAddon.estimate = addon;
					} else {
						allSubscription.addons.push({
							name: addon.name,
							addon_id: addon.addon_id,
							estimate: addon,
							billing_period: subscription.billing_period,
						} as any);
					}
				});

				const monthlySubscription = subscription.monthly_sub_item;
				if (monthlySubscription) {
					monthlySubscription.addons.forEach((addon) => {
						const existAddon = allSubscription.addons.find(
							(x: any) =>
								x.addon_id === addon.addon_id && x.billing_period === monthlySubscription.billing_period
						);
						if (existAddon) {
							existAddon.estimate = addon;
						} else {
							allSubscription.addons.push({
								name: addon.name,
								addon_id: addon.addon_id,
								estimate: addon,
								billing_period: monthlySubscription.billing_period,
							} as any);
						}
					});
				}
			}
		});
	return allSubscriptions;
};
